import React, { PropsWithChildren } from "react"

import { getConfig } from "@cirrus/config"
import { useHttp } from "@cirrus/core/http/provider"

import { LoginServiceProvider } from "./context"
import { LoginService } from "./service"

const config = getConfig()

export const LoginServiceDecorator = ({children}: PropsWithChildren) => {

  const { http } = useHttp()

  return (
    <LoginServiceProvider service={new LoginService({ config, http })}>{children}</LoginServiceProvider>
  )
}